<template>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">Documents</h4>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">

            <div class="fresh-datatables">
              <table id="datatables" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Uploaded By</th>
                    <th>Uploaded Date</th>
                    <th class="disabled-sorting"></th>
                  </tr>
                </thead>
                <tbody>
                    <template v-for="(doc, idx) in documents">
                      <tr :key="doc.id || idx">
                        <td><a href="javascript:void(0);" v-on:click="downloadFile(doc, idx)">{{doc.fileName}}</a></td>
                        <td>{{doc.uploadedBy}}</td>
                        <td>{{doc.uploadedDate}}</td>
                        <td><a @click="confirmDeleteDocument(doc.id, idx)" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a></td>
                      </tr>
                    </template>
                </tbody>
              </table>
            </div>

          </div>
        </div>


        <div class="row">
          <div class="col-12">
              <div class="dropbox">
                <input type="file" name="uploadInput" :disabled="isUploading" @change="filesChange($event.target.name, $event.target.files);" accept="*/*" class="input-file">
                <p v-if="!currentUploadFile">
                  <i class="fa fa-upload"></i><br>
                  Drag your file here or click to browse...
                </p>
                <p v-if="isUploading">
                  Uploading file..
                </p>
                <p v-if="currentUploadFile">
                  <i class="fa fa-upload"></i><br>
                  {{ currentUploadFile.name }}
                </p>
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <button class="btn btn-icon btn-wd btn-success" :disabled="!currentUploadFile" @click="uploadToServer()"><i class="fa fa-upload"></i> Upload</button>
            <button class="btn btn-icon btn-wd btn-success" v-if="showGenerate"  @click="showGenerateModal()"> Generate Report</button>
          </div>
        </div>


      </div>
    </div>
  </div>



  <modal name="generateModal" height="auto">
    <div class="col-sm-12" style="display:inline-block;">
      <div class="form-group" style="padding-top: 12px">
        <h4 class="card-title">Generate Report</h4>
      </div>

      <div class="card-body form">
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="generateType">Select a report to generate and download</label>
              <select class="form-control" v-model="generateType">
                <option id="pickupOrder" selected>Pick-up Order</option>
                <option id="proForma">Pro Forma</option>
              </select>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-12">
          </div>
          <div class="col-sm-12">
            <div class="form-group form-actions float-right" style="margin-bottom: 16px">
              <button type="button" class="btn btn-default" @click="hideGenerateModal()">Cancel</button>
              <button class="btn btn-success btn-wd" @click="generateDocument()"><i class="fa fa-download"></i> Generate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>


</div>

</template>
<script>

import Vue from 'vue'
import axios from 'axios';
import apiService from '../services/api.service'
import moment from 'moment';

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { generatePickupOrder, generateProForma } from '../utils/pdf';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: 'uploadDocuments',

  data: function () {
    return {
      currentUploadFile: null,
      generateType: 'Pro Forma',
      isUploading: false,
    }
  },

  props: {
    showGenerate: {
      type: Boolean,
      required: false
    },
    saveLocal: {
      type: Boolean,
      required: false,
    },
    documents: {
      type: Array,
      default: () => [],
    },
    rfqId: {
      type: String,
      required: false,
    },
    rfq: {
      type: Object,
      required: false,
    }
  },

  mounted () {
    console.log("uploadDocument mounted!");
  },

  methods: {

    filesChange(fieldName, fileList) {

      console.log(fieldName);
      console.log(fileList);
      // handle file changes
      const formData = new FormData();

      if (!fileList.length) return;
      if (fileList[0].size > 100 * 1024 * 1024) {
        return Vue.toasted.error("Please choose a file less than 100MB", {duration: 3500})
      }
      this.currentUploadFile = fileList[0];

      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map(x => {
        formData.append(fieldName, fileList[x], fileList[x].name);
      });

      // save it
      //this.save(formData);

      this.$forceUpdate();
    },

    showGenerateModal() {
      this.$modal.show("generateModal");
    },

    hideGenerateModal() {
      this.$modal.hide("generateModal");
    },

    async generateDocument() {

      try {
        console.log(`Generating document... ${this.generateType}`);
        if (this.generateType == 'Pro Forma') {
          const pdfDoc = await generateProForma(this.rfq);
          pdfDoc.download(`${(this.rfq.customer.transferOrder) ? this.rfq.customer.transferOrder + ' ': ''}proForma.pdf`);
        } else {
          const pdfDoc = await generatePickupOrder(this.rfq, this.rfqId);
          pdfDoc.download(`${(this.rfq.customer.transferOrder) ? this.rfq.customer.transferOrder + ' ': ''}pickupOrder.pdf`);
        }
        this.hideGenerateModal();
      } catch(e) {
        Vue.toasted.error("Problem generating document: " + e, {duration: 3500})
      }
    },

    async uploadToServer() {
      console.log("uploading!");
      console.log(this.currentUploadFile);
      const name = localStorage.getItem('local_name');
      if(!this.currentUploadFile) return;
      if(this.saveLocal){
        const fileData = {
          fileName: this.currentUploadFile.name,
          cloudName: '',
          uploadedBy: name,
          uploadedDate: moment(new Date()).format('LL'),
          file: this.currentUploadFile,
        }
        this.$emit('fileAdded', fileData);
        this.currentUploadFile = null;
        return;
      }
      try {
        const signedResponse = await apiService.post('/rfq/signedUploadUrl', {
          fileName: this.currentUploadFile.name
        });
        const {signedUrl, cloudName} = signedResponse.data;
        if(!signedUrl) {
          throw new Error("Unable to get signed upload url")
        }
        const headers = {
            'Content-Type': 'application/octet-stream'
        }
        await axios.put(signedUrl, this.currentUploadFile, {headers});
        const fileData = {
          fileName: this.currentUploadFile.name,
          cloudName: cloudName,
          uploadedBy: name,
          uploadedDate: moment(new Date()).format('LL')
        }
        this.$emit('fileUploaded', fileData)
        this.currentUploadFile = null;
      } catch (error) {
        console.log('Error uploading document: ', error);
      }
    },

    confirmDeleteDocument( docId, index) {
      console.log(this.rfqId, docId);
      console.log(this.documents);
      if(confirm('Are you sure you want to delete this document?\n' + this.documents[index].fileName)){
        if(this.saveLocal) {
          this.$emit('deleteLocalDocument', index)
        } else {
          const documentIds = {
            rfqId: this.rfqId,
            docId: docId,
          }
          this.$emit('deleteUploadedDocument', documentIds )
        }
      }
    },
    async downloadFile({cloudName, fileName}, idx) {
      if(this.saveLocal) {
        const { file} = this.documents[idx];
        this.downloadBlob(file, fileName)
        return;
      }
      try {
        const res = await apiService.post('/rfq/signedDownloadUrl', {
          cloudName: cloudName
        })
        const gcsRes = await axios.get(res.data.signedUrl, {
          responseType: 'blob'
        })
        this.downloadBlob(gcsRes.data, fileName)
      } catch (error) {
        console.log(error);
      }
    },
    downloadBlob (blob, fileName) {
      let fileURL = window.URL.createObjectURL(new Blob([blob]));
      let fileLink = document.createElement('a');
      fileLink.href = fileURL;
      fileLink.setAttribute('download', fileName);
      document.body.appendChild(fileLink);
      fileLink.click();
    }
  }

}

</script>

<style lang="css">
  .dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    color: dimgray;
    padding: 10px 10px;
    min-height: 90px;
    max-height: 9px;
    position: relative;
    cursor: pointer;
  }

  .input-file {
    opacity: 0;
    width: 100%;
    height: 90px;
    position: absolute;
    cursor: pointer;
  }

  .dropbox:hover {
    background: lightcyan;
  }

  .dropbox p {
    font-size: 0.9em;
    text-align: center;
    padding: 12px 0;
  }
</style>



// WEBPACK FOOTER //
// UploadDocument.vue?b793687a